export default "__VITE_ASSET__DRu$jhE8__"